module.exports = __webpack_public_path__ + "img/ICONACHIEVE.20fcf4e4.webp";